import React, {Component} from 'react';
import {Col, Container, Row} from "react-bootstrap";

class Title extends Component {
    render() {
        return (

            <div>
                <h3 className="site-name" style={{color: '#fff'}}>
                    HIP Database
                </h3>
            </div>
        );
    }
}

export default Title;


// WEBPACK FOOTER //
// ./src/components/header/Title.js